import _debounce from 'lodash/debounce';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Slider, StyledSliderTrack, token, StyledSliderThumb, SliderLabel } from '@zillow/constellation';
import { getWholeDollars } from '../../utils/zhl-calculator.js';
import { handleFieldChangeEvent } from './DTICalculator.clickstream.js';

var StyledSlider = /*#__PURE__*/styled(Slider).withConfig({
  componentId: "sc-1dsrlzi-0"
})(["", "{height:8px;}", ":nth-child(1){background-color:", ";}", ":nth-child(2){background-color:", ";}", ":nth-child(3){background-color:", ";}", "{visibility:hidden;}", " ~ ", "{visibility:visible;top:2px;}"], StyledSliderTrack, StyledSliderTrack, token('colors.orange500'), StyledSliderTrack, token('colors.blue600'), StyledSliderTrack, token('colors.brand'), StyledSliderThumb, StyledSliderThumb, StyledSliderThumb);
var DTISlider = function DTISlider(_ref) {
  var monthlyIncome = _ref.monthlyIncome,
    debtsOut = _ref.debtsOut,
    mortgagePayment = _ref.mortgagePayment,
    inputValue = _ref.inputValue,
    onSliderChange = _ref.onSliderChange;
  var onSliderChangeDebounced = useMemo(function () {
    return _debounce(function (value) {
      onSliderChange(value);
      handleFieldChangeEvent('Debt slider', 'slider');
    }, 50);
  }, [onSliderChange]);
  return /*#__PURE__*/React.createElement(StyledSlider, {
    withTracks: true,
    max: monthlyIncome,
    value: [debtsOut, mortgagePayment + debtsOut],
    onChange: onSliderChangeDebounced,
    snapDragDisabled: true,
    step: 10,
    ariaLabel: "total monthly payment",
    ariaValuetext: "$" + inputValue + " per month"
    // The default `renderThumb` prop hard-codes `aria-labelledby` for `StyledSliderThumb` -
    // since we provide `ariaLabel` instead, we omit `aria-labelledby`.
    ,
    renderThumb: function renderThumb(thumbProps) {
      return /*#__PURE__*/React.createElement(StyledSliderThumb, thumbProps, /*#__PURE__*/React.createElement(SliderLabel, {
        style: {
          display: 'inline-flex',
          width: 'max-content',
          top: '-55px',
          padding: '8px'
        },
        id: thumbProps.key
      }, '$' + getWholeDollars(inputValue) + '/mo'));
    }
  });
};
DTISlider.propTypes = process.env.NODE_ENV !== "production" ? {
  monthlyIncome: PropTypes.number,
  debtsOut: PropTypes.number,
  mortgagePayment: PropTypes.number,
  inputValue: PropTypes.number,
  onSliderChange: PropTypes.func.isRequired
} : {};
var DTISlider$1 = DTISlider;

export { DTISlider$1 as default };
